<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="5" height="15" fill="black"/>
<rect x="13" y="3" width="5" height="15" fill="black"/>
</svg>
